interface Props {
  // Anything: an already-parsed object, a (possibly truncated) raw string, or
  // null/empty. Objects are pretty-printed; strings are first probed as JSON
  // and pretty-printed if parseable, otherwise shown verbatim.
  value: unknown;
}

function format(value: unknown): { text: string; empty: boolean } {
  if (value === null || value === undefined) {
    return { text: '', empty: true };
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '') return { text: '', empty: true };
    try {
      return { text: JSON.stringify(JSON.parse(trimmed), null, 2), empty: false };
    } catch {
      // Not JSON (e.g. a truncated body or plain text) — show as-is.
      return { text: value, empty: false };
    }
  }

  try {
    return { text: JSON.stringify(value, null, 2), empty: false };
  } catch {
    return { text: String(value), empty: false };
  }
}

// Pretty-printed <pre>, matching the JSON blocks in CallbackDocsModal.
export function JsonBlock({ value }: Props) {
  const { text, empty } = format(value);

  if (empty) {
    return (
      <div className="rounded bg-[var(--co-bg)] p-3 text-xs text-[var(--co-muted)]">
        (empty)
      </div>
    );
  }

  return (
    <pre className="overflow-x-auto whitespace-pre-wrap break-all rounded bg-[var(--co-bg)] p-3 font-mono text-xs text-[var(--co-text)]">
      {text}
    </pre>
  );
}
